<div class="db-optimize-images" [ngClass]="{'loading': ((loadingWebpFormat || loading) && !pageLayout)}">
  <db-loading-screen *ngIf="(loadingWebpFormat || loading) && !pageLayout && !optimizerDisabled" [pageBlocker]="true"></db-loading-screen>
  <div class="db-optimize-images__header">
    <!--<img src="assets/images/booster/optimize-images.png" alt="">-->
    <div>
      <h1 [innerHTML]="'text_speedOptimizerTitle' | dbText"></h1>
      <p [innerHTML]="'text_speedOptimizerDesc' | dbText"></p>
    </div>
  </div>

  <div class="db-optimize-images__content">
    <div class="db-optimize-images__images">
      <div class="db-optimize-images__block">
        <div class="db-optimize-images__ready-optimize" [ngClass]="{'all-optimize': !loading && !stats?.notCompressed && !stats?.notCompressedFull}">
          <div>
            <div class="ds-notification-success small mb10">
              <div>
                <i class="db-icon db-icon-ds-checkmark-bg"></i>
                <span class="semibold">Optimized for free</span>
              </div>
            </div>
            <p class="db-optimize-images__ready-optimize-title mb12"
               [innerHTML]="'text_speedOptimizerImagesCountFree' | dbText : {count: optimizedImagesSum}">
            </p>
            <p class="db-optimize-images__ready-optimize-desc mb20"
               [innerHTML]="'text_speedOptimizerImagesInLibraryFree' | dbText">
            </p>
            <div class="db-optimize-images__optimized-images">
              <div class="db-optimize-images__optimized-images-title">Optimized pages <span>{{optimizedPages?.length}} of {{currentSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value}}</span></div>
              <div class="db-optimize-images__optimized-images-section"><div [ngStyle]="{'width': optimizedPages?.length ? 'calc(100%/' + ((currentSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value) ) / optimizedPages?.length  + ')' : '0px'}"></div></div>
              <div class="db-optimize-images__optimized-images-body-title">
                <p *ngFor="let page of pagesCompressed; let index = index" [ngClass]="{'mt10': index !== 0}">
                  <span [innerHTML]="page?.url === websiteUrl ? 'Homepage' : (page?.url | trimHomeUrl: websiteUrl)"></span>
                  <span *ngIf="!loadingOptimizedPage || (loadingOptimizedPage && page?.pageId !== optimizingPageId)"><span *ngIf="page?.imagesCount">{{page?.imagesCount}} images</span><i class="db-icon db-icon-ds-checkmark-bg ml5"></i></span>
                  <span *ngIf="loadingOptimizedPage && page?.pageId === optimizingPageId" class="ds-spinner-circle"></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="db-optimize-images__block not-compressed">
        <div>
          <div class="ds-notification-error small mb10">
            <div>
              <i class="db-icon db-icon-ds-close-bg"></i>
              <span class="semibold">Not optimized</span>
            </div>
          </div>
          <p class="db-optimize-images__ready-optimize-title mb12"
             [innerHTML]="'text_speedOptimizerImagesCountFree' | dbText : {count: stats?.notCompressed || 0}">
          </p>
          <p class="db-optimize-images__ready-optimize-desc">
            <span class="mb4"><i class="circle"></i>Optimize images of your entire website</span>
            <span><i class="circle"></i>Auto optimize new images uploaded to the media library</span>
          </p>
        </div>

        <div class="db-optimize-images__upgrade mt20">
          <p>
            <i class="db-icon db-icon-ds-diamond"></i>
            <span *ngIf="!showPercentOffer">Try 10Web Booster<br/> Pro for 7 days</span>
            <span *ngIf="showPercentOffer">Available with<br/> 10Web Booster Pro</span>
          </p>
          <a class="ds-btn ds-btn-green" (click)="setAutoOptimize()">
            <span>{{(showPercentOffer ? 'text_upgrade' : 'text_tryForFree') | dbText | lowerCaseSpecificWords}}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="db-optimize-images__notification" *ngIf="currentSubscription?.trialBoosterClient">
      <div class="ds-notification-error" *ngIf="error">
        <div>
          <i class="db-icon db-icon-ds-close-bg"></i>
          <span [innerHTML]="'text_speedOptimizerWentWrong' | dbText"></span>
        </div>
      </div>
    </div>

    <form [formGroup]="imageOptimizerSettings">
      <div class="db-optimize-images__block">
        <db-loading-screen *ngIf="loadingAutoOptimize"></db-loading-screen>
        <div>
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="'text_speedOptimizerAutomaticOptimizationFree' | dbText"></p>
            <span class="db-optimize-images__block-desc" [innerHTML]="'text_speedOptimizerAutomaticOptimizeDescFree' | dbText"></span>
          </div>
          <div class="db-switch-wrap">
            <p (click)="setAutoOptimize()">{{(showPercentOffer ? 'text_upgrade' : 'text_tryForFree') | dbText}} and enable</p>
          </div>
        </div>
      </div>

      <div *ngIf="!pageLayout && !websiteHosted" class="db-optimize-images__block">
        <div>
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="'text_speedOptimizerWebPFormat' | dbText"></p>
            <span class="db-optimize-images__block-desc"
                  [innerHTML]="(websiteHosted ? 'text_speedOptimizerWebPFormatHostedDesc' : 'text_speedOptimizerWebPFormatDesc') | dbText"></span>
          </div>
          <div class="db-switch-wrap" *ngIf="!!boosterSettings?.webpDeliveryWorking && boosterSettings?.hosting !== 'NGINX'">
            <input id="webp-switcher" class="ds-switcher-green ds-control-small auto-optimize-settings" type="checkbox"
                   (change)="setWebpStatus()" formControlName="webpStatus" [value]="boosterSettings?.webpStatus">
            <label for="webp-switcher">
              <span class="ds-switcher-control"></span>
            </label>
          </div>
        </div>

        <div class="db-optimize-images__note" *ngIf="websiteId && boosterSettings && !websiteHosted
        && ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking)">
          <div>
            <h3 [innerHTML]="'text_serverConfiguration' | dbText"></h3>
            <div>
              <div class="db-optimize-images__note-info">
                <p class="db-optimize-images__block-desc note">
                  <span [innerHTML]="'text_speedOptimizerNote' | dbText"></span>
                  <a (click)="showWebPServerDialog()">these instructions</a>
                </p>
                <p class="db-optimize-images__block-desc note">
                  <span [innerHTML]="'text_speedOptimizerNoteAfterCompleting' | dbText"></span>
                </p>
              </div>
              <div class="db-optimize-images__webp-status" (click)="getWebpStatus()"
                   [ngClass]="{'active': webpServerConfigIsActive, 'inactive': !webpServerConfigIsActive}">
                <p>
                  <i class="db-icon db-icon-{{webpServerConfigIsActive ? 'ds-circle-filled' : 'ds-close-bg'}}"></i>
                  <span>{{webpServerConfigIsActive ? 'Active' : 'Inactive'}}</span>
                </p>
                <i class="db-icon db-icon-ds-refresh"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="db-optimize-images__note use-picture"
             *ngIf="websiteId && !websiteHosted && boosterSettings && ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking) && !webpServerConfigIsActive">
          <div>
            <h3>{{'text_usePictureTags' | dbText}}</h3>
            <div>
              <div class="db-optimize-images__note-info">
                <p class="db-optimize-images__block-desc note">
                  <span>{{'text_usePictureTagsDesc1' | dbText}}</span>
                </p>
                <p class="db-optimize-images__block-desc note">
                  <span>{{'text_usePictureTagsDesc2' | dbText}}</span>
                </p>
              </div>
              <div class="db-switch-wrap">
                <input id="picture-tag-switcher" class="ds-switcher ds-control-small auto-optimize-settings" type="checkbox"
                       (change)="setWebpStatus()" formControlName="pictureWebpStatus">
                <label for="picture-tag-switcher">
                  <span class="ds-switcher-control"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</div>
